import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function VehicleColorRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/vehicle-color', component: Index, isProtected: true, permissions: ['vehicle_color_index']},
    {path: '/vehicle-color/create', component: Create, isProtected: true, permissions: ['vehicle_color_create']},
    {path: '/vehicle-color/edit/:id', component: Edit, isProtected: true, permissions: ['vehicle_color_edit']},

  ];

  return routes;
}
